/* eslint-disable import/no-extraneous-dependencies */
import { track as mixpanelTrack } from "common/utils/mixpanel/tracker";
import { track as clarityTrack } from "common/utils/clarity/tracker";
import { track as rudderstackTrack } from "common/utils/rudderstack/tracker";

export { sendDataLayer, sendDataLayerOnLinkClickEvent } from "common/utils/ga";
export { registerMixpanel } from "common/utils/mixpanel/tracker";
export { initMixpanelEvents } from "common/utils/mixpanel/init-mixpanel-events";

export const track = (event, rest, options) => {
  mixpanelTrack(event, rest, options);
  clarityTrack(event, rest);
};

export const trackRudderstack = (event, rest, sendToMixpanel = false) => {
  rudderstackTrack(event, rest, sendToMixpanel);
};

/**
 * Creates a fire-once IntersectionObserver that tracks a `promo_view` event.
 * @param {HTMLElement} $element
 * @param {string} location
 * @param {{ promoShown?: string, promoVariant?: string }} [options]
 * @returns {IntersectionObserver}
 */
export const createPromoViewObserver = ($element, location, options = {}) => {
  let fired = false;
  const observer = new IntersectionObserver(
    entries => {
      const entry = entries[0];
      if (!entry || !entry.isIntersecting || fired) return;

      fired = true;
      const props = {
        is_peekaboo_tile: entry.intersectionRatio < 0.5,
        location,
        promo_shown: options.promoShown
      };
      if (options.promoVariant && options.promoVariant !== options.promoShown) {
        props.promo_variant = options.promoVariant;
      }
      track("promo_view", props);

      observer.disconnect();
    },
    { threshold: [0, 0.5] }
  );

  observer.observe($element);
  return observer;
};
